import React from 'react';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFolder, faUpload } from '@fortawesome/free-solid-svg-icons';

interface EmptyStateProps {
  onNewFolder: () => void;
  onUpload: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onNewFolder, onUpload }) => {
  // Role-based permissions
  const canAccess = useSelector((state: any) => state.auth.permissions?.opsmanual);

  return (
    <div className="text-center py-5">
      <FontAwesomeIcon icon={faFolder} size="4x" className="text-muted mb-3" />
      <h4>This folder is empty</h4>
      <p className="text-muted">Get started by creating a new folder or uploading files</p>
      <div className="mt-3">
        {canAccess?.['create-new-folder'] && (
          <button className="btn btn-primary mr-2" onClick={onNewFolder}>
            <FontAwesomeIcon icon={faFolder} className="mr-1" />
            New Folder
          </button>
        )}
        {canAccess?.['upload-document'] && (
          <button className="btn btn-success" onClick={onUpload}>
            <FontAwesomeIcon icon={faUpload} className="mr-1" />
            Upload Files
          </button>
        )}
        {!canAccess?.['create-new-folder'] && !canAccess?.['upload-document'] && (
          <p className="text-muted">
            <i className="fas fa-info-circle mr-2"></i>
            You don't have permission to create folders or upload files.
          </p>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
